export const IsDefinedNotNull = (data: any) => {
    return data !== undefined && data !== null
}
